import Blue from "~/core";

new Blue({
	name: 'Android App Banner',
	selector: "#android-app-banner",
	setup(androidAppBanner) {
    const ua = navigator.userAgent.toLowerCase();
		const android = ua.indexOf("android") > -1;
		const close = androidAppBanner.querySelector('.appBanner__close');
		const header = document.querySelector(".header");
		const drawer = document.querySelector(".header__drawer");
    const media = window.matchMedia(`(min-width: 992px)`);

		this.$addEvents(window, 'resize', () => {
			if(!media.matches) {
				androidAppBanner.classList.remove('hidden');
			} else {
				androidAppBanner.classList.add('hidden');
			}
		});

		if(android) {
			androidAppBanner.classList.remove('hidden');
		}

		if(this.$getCookie('androidBannerCookie')) {
			androidAppBanner.remove();
		}
		
		this.$addEvents(close, 'click touch', () => {
			this.$setCookie('androidBannerCookie', true, 8);
			androidAppBanner.style.display = 'none';
			document.body.style.marginTop = `${header.offsetHeight}px`;
      document.documentElement.style.setProperty("--header-height", `${header.offsetHeight}px`);
			drawer.style.marginTop = `${header.offsetHeight}px`;
		});
	}
});